"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerComponent = ContainerComponent;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const ScreenAmountProfile = __importStar(require("../screen-amount-profile"));
const Component = __importStar(require("./genesys-properties-selector-component"));
const GenesysPropertiesSelectorRenderers = __importStar(require("../genesys-properties-selector-renderers"));
function ContainerComponent({ lockSingleValidValue = false, activatedQuantitySelectors, customTranslation, dispatch, closedGroups, hidePropertyNames, includeCodes, includeHiddenProperties = false, layoutRenderer = GenesysPropertiesSelectorRenderers.stackedWithGroupsLayoutRenderer, productProperties, onChange, readOnlyProperties, sections, selectedProperties, screenAmountProfileFieldGroup, uniqueId, onDelete = () => ({}), valueSources, groupFilter = [], showGroups = true, showDelete = false }) {
    return (React.createElement(ScreenAmountProfile.ScreenAmountProfile, null, ({ getAmountFormat, measureSystem, quantityDefaults, saveAmountFieldFormat, deleteAmountFieldFormat }) => {
        const validationErrors = validatePropertyValueSetSameAsProductProperties(selectedProperties, productProperties);
        if (validationErrors.length > 0) {
            const stringifiedError = validationErrors.reduce((soFar, current) => soFar +
                `Propery: ${current.propertyName}, was: ${current.actual}, expected: ${current.expected} \n`, "");
            throw new Error(`PropertValueSet contains properties with different quantities than product property definition \n ${stringifiedError}`);
        }
        const propertyFormats = buildPropertyFormats(getAmountFormat, screenAmountProfileFieldGroup, productProperties);
        const onPropertyFormatChanged = (fieldName, unit, decimalCount) => {
            saveAmountFieldFormat(screenAmountProfileFieldGroup, fieldName, unit, decimalCount);
        };
        const onPropertyFormatCleared = (propertyName) => {
            deleteAmountFieldFormat(screenAmountProfileFieldGroup, propertyName);
        };
        return (React.createElement(Component.GenesysPropertiesSelectorComponent, { activatedQuantitySelectors: activatedQuantitySelectors, lockSingleValidValue: lockSingleValidValue, closedGroups: closedGroups, customTranslation: customTranslation, dispatch: dispatch, includeCodes: includeCodes, includeHiddenProperties: includeHiddenProperties, getAmountFormat: getAmountFormat, groupFilter: groupFilter, showGroups: showGroups, hidePropertyNames: hidePropertyNames, layoutRenderer: layoutRenderer, originalProductProperties: productProperties, measureSystem: measureSystem, onChange: onChange, onPropertyFormatChanged: onPropertyFormatChanged, onPropertyFormatCleared: onPropertyFormatCleared, propertyFormats: propertyFormats, quantityDefaults: quantityDefaults, readOnlyProperties: readOnlyProperties, sections: sections, selectedProperties: selectedProperties, uniqueId: uniqueId, onDelete: onDelete, fieldGroup: screenAmountProfileFieldGroup, valueSources: valueSources, showDelete: showDelete }));
    }));
}
function validatePropertyValueSetSameAsProductProperties(pvs, productProperties) {
    const soFar = [];
    for (const pp of productProperties) {
        const property = property_1.PropertyValueSet.getAmount(pp.name, pvs);
        if (!property || pp.quantity === property.unit.quantity) {
            continue;
        }
        soFar.push({
            propertyName: pp.name,
            actual: property.unit.quantity,
            expected: pp.quantity
        });
    }
    return soFar;
}
function buildPropertyFormats(getAmountFormat, fieldGroup, productProperties) {
    const propertyFormats = productProperties.reduce((soFar, pp) => {
        if (pp.quantity === "Discrete" || pp.quantity === "Text") {
            return soFar;
        }
        const amountFormat = getAmountFormat(fieldGroup, pp.fieldName || pp.name, pp.quantity);
        // PropertyFormats doesn't handle quantity conversion. We do it amount property selector instead.
        if (amountFormat.unit.quantity !== pp.quantity) {
            return soFar;
        }
        soFar[pp.name] = amountFormat;
        return soFar;
    }, {});
    return propertyFormats;
}
//# sourceMappingURL=container-component.js.map